import { COOKIE_MORTGAGE_SEARCH } from '@/constants/cookies';
import { MORTGAGE_STEPS } from '@/constants/mortgages';
import { getMortgageSearch } from '@/graphql/queries/banking/mortgage';
import lang from '@/lang/middleware/products/mortgage';

export default async ({ $apolloQuery, app, $cookies, redirect, route, store }) => {
  const code = $cookies.get(COOKIE_MORTGAGE_SEARCH);
  const purpose = { 'first-time-buyer': 'FTB', 'moving-home': 'TRD', 'switching-mortgage': 'SM' }[route.params.purpose];

  const backHome = () => {
    $cookies.remove(COOKIE_MORTGAGE_SEARCH);
    redirect(302, app.localePath('/compare-mortgages/'));
  };

  if (route.params.step && !MORTGAGE_STEPS.includes(route.params.step)) backHome();

  store.$i18n.mergeLocaleMessage('en', lang.en);
  const description = store.$i18n.t('search.description');
  const title = store.$i18n.t('search.title');
  store.commit('pageContent/setHead', { description, title });

  if (code && purpose) {
    await $apolloQuery(getMortgageSearch, { code })
      .then(search => store.commit('search/setSearchAndTemp', search))
      .catch(_ => backHome());
  }
};
